<template>
  <div v-if="albumAccess.pending"></div>
  <album-access-notice v-else-if="!albumAccess.ready" :message="albumAccess.error" @retry="retryAccess"></album-access-notice>
  <van-empty image="search" :description="hauce_errmsg" v-else-if="huace_status == 0"></van-empty>
  <div v-else>
    <div class="app-container" v-if="is_fang == 1">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive"></router-view>
    </div>

    <section class="aui-flexView" v-else>
      <br />
      <section class="aui-scrollView">
        <div class="aui-code-box">
          <h2>绑定手机号</h2>
          <br />
          <p>绑定手机号后才能继续浏览画册</p>
          <div class="form1">
            <p class="aui-code-line">
              <em>+86</em>
              <input type="text" class="aui-code-line-input" name="search" v-model="phone" autocomplete="off"
                placeholder="请输入手机号" style="padding-left: 28px" />
            </p>
            <p class="aui-code-line aui-code-line-clear">
              <input id="code1" type="text" v-model="code" class="aui-code-line-input" autocomplete="off"
                placeholder="短信验证码" />
              <input id="btnSendCode1" type="button" class="aui-btn-default" :value="btntxt" :disabled="disabled"
                @click="sendcode" />
            </p>
            <p class="aui-code-btn">
              <button @click="bind">绑定并继续浏览</button>
            </p>
          </div>
        </div>
      </section>
    </section>
  </div>
</template>

<script>
  import {
    Dialog
  } from "vant";
  import {
    Toast
  } from "vant";
  import Vue from 'vue';
  import Vconsole from 'vconsole';
  import {
    buildRouteUrl
  } from './utils/share-url';
  import AlbumAccessNotice from './components/AlbumAccessNotice';
  import { albumAccess } from './utils/album-access';
  import { retryAlbumAccess } from './router';
  export default {
    components: { AlbumAccessNotice },
    data() {
      return {
        albumAccess: albumAccess,
        active: "home",
        id: "id",
        share_title: "",
        disabled: false,
        time: 0,
        btntxt: "获取验证码",
        phone: "",
        is_fang: 1,
        code: "",
        huace_status: "1",
        hauce_errmsg: "",
        entryReady: false,
      };
    },
    methods: {
      retryAccess() { retryAlbumAccess(); },
      //验证手机号码部分
      sendcode() {
        var app = this;
        var reg = /^[1][1,2,3,4,5,6.7,8,9,0][0-9]{9}$/;
        if (this.phone == "") {
          Dialog.alert({
            message: "请输入手机号码",
          }).then(() => {});
          return;
        } else if (!reg.test(this.phone)) {
          Dialog.alert({
            message: "手机格式不正确",
          }).then(() => {});
          return;
        } else {
          var id = this.$route.query.id;
          var token = localStorage.getItem("token");
          Toast.loading({
            message: "请求中...",
            forbidClick: true,
          });
          this.$http
            .post(
              api_url +
              "action=send_phone_msg&id=" +
              id +
              "&phone=" +
              this.phone +
              "&token=" +
              token
            )
            .then(function(res) {
              if (res.data.sta == 200) {
                Toast.success(res.data.msg);
                app.time = 60;
                app.disabled = true;
                app.timer();
              } else {
                Dialog.alert({
                  message: res.data.msg,
                }).then(() => {});
                return;
              }
            });
        }
      },
      // 验证码倒计时
      timer() {
        if (this.time > 0) {
          this.time--;
          this.btntxt = this.time + "s后重新获取";
          setTimeout(this.timer, 1000);
        } else {
          this.time = 0;
          this.btntxt = "获取验证码";
          this.disabled = false;
        }
      },
      bind() {
        var id = this.$route.query.id;
        var token = localStorage.getItem("token");
        var code = this.code;
        var phone = this.phone;
        var app = this;
        Toast.loading({
          message: "验证中...",
          forbidClick: true,
        });
        this.$http
          .post(
            api_url +
            "action=bind_phone&code=" +
            code +
            "&phone=" +
            phone +
            "&token=" +
            token
          )
          .then(function(res) {
            if (res.data.sta == 200) {
              Toast.success(res.data.msg);
              setTimeout(function() {
                app.is_fang = 1;
              }, 1500);
            } else {
              Toast.fail(res.data.msg);
            }
          });
      },

      isWeiXin() {

        var ua = window.navigator.userAgent.toLowerCase();
        if (/wxwork/i.test(navigator.userAgent)) {
          console.log("是企业微信");
          // 是企业微信
          this.initApp("wxwork")
        } else if (ua.match(/MicroMessenger/i) == 'micromessenger') {
          console.log("是普通微信");
          // 是普通微信
          this.initApp("MicroMessenger")
        } else {
          console.log("是其他浏览器");
          //是其他浏览器
          this.initApp("other")
        }
      },

      initApp(ua_name) {
        console.log("ua_name:", ua_name);
        //路由path
        var route_path = this.$route.path;
        if (!this.albumAccess.ready) return;
        //console.log("route_path", route_path)
        //接受到id参数
        var id = this.$route.query.id;
        var app = this;
        var cat_id = this.$route.query.cat_id

        //这个页面只展示产品的信息，和现有画册逻辑无关系。所以单独弄个页面出来
        if (route_path == "/detail1" || route_path == "/fangandetail") {
          console.log("在app.vue中绕过了所有的校验");

        } else {
          if (!!id == false) {
            this.huace_status = 0;
            this.hauce_errmsg = "电子画册id信息丢失!";
            return;
          }

          //先根据画册的id获取客户信息，然后判断是否需要注册会员，也就是后续接口是否需要token
          app.$http
            .post(api_url + "action=get_config&id=" + id + "&host=" + window.location.hostname + "&ua_name=" + ua_name)
            .then((res) => {
              if (res.data.sta != "200") {
                this.huace_status = 0;
                this.hauce_errmsg = res.data.msg;
                //Toast.fail(res.data.msg);
                return;
              }
              //判断是否需要跳转
              if (res.data.res.is_tz == 1) {
                const currentDomain = window.location.hostname;
                const urlPath = window.location.pathname;
                const queryStr = window.location.search;
                const hashStr = window.location.hash;
                const originalParams = urlPath + queryStr + hashStr;
                console.log("currentDomain:", currentDomain);
                //使用的逗号拼接的多个域名
                const history_huace_domain = res.data.res.history_huace_domain;
                // 将逗号分隔的字符串转为数组
                const domainList = history_huace_domain.split(',');
                // 检查当前域名是否在允许的列表中
                if (domainList.includes(currentDomain)) {
                  let targetDomain = res.data.res.current_huace_url;
                  let finalUrl = targetDomain + originalParams;
                  console.log("targetDomain:", finalUrl);
                  if (targetDomain != '') {
                    window.location.href = finalUrl;
                    return;
                  }
                }
              }

              //调试模式是否开启来看
              if (res.data.res.is_debug == 1) {
                let vConsole = new Vconsole()
                Vue.use(vConsole)
              }

              //是否应用过期禁止访问了
              if (res.data.res.is_application_expired == 1) {
                this.huace_status = 0;
                this.hauce_errmsg = "画册系统已过期，请提醒画册所有方续费！";
                return;
              }

              //处理正常业务逻辑，数据赋值
              this.id = res.data.res.id;
              this.share_title = res.data.res.share_title;
              this.is_fang = res.data.res.is_fang;
              this.client_is_reg_member = res.data.res.client_is_reg_member; //是否允许注册会员
              //如果这个变量等于1

              if (res.data.res.client_is_reg_member == '1') {
                //授权地址来自配置接口，token 校验响应不包含该字段。
                var weixinAuthUrl = res.data.res.weixin_auth_url;
                var redirectToWechatAuth = () => {
                  localStorage.removeItem("token");
                  var authQuery = Object.assign({}, app.$route.query);
                  delete authQuery.token;
                  var url_back = escape(buildRouteUrl(route_path, authQuery));
                  window.location.href = weixinAuthUrl +
                    "/api.php/index/index?action=redirect_to_wechat_oauth&id=" + id + "&url=" + url_back;
                };
                //如果缓存里面的token为空，或者get到的token为空，则需要去接口授权获取
                if (
                  !!!!app.$route.query.token == false &&
                  !!!!localStorage.getItem("token") == false
                ) {
                  redirectToWechatAuth();
                  return;
                }
                //如果get到token则存入本地缓存
                if (!!app.$route.query.token == true) {
                  localStorage.setItem("token", app.$route.query.token);
                }
                var token = localStorage.getItem("token");
                if (!!app.$route.query.token == true) {
                  var cleanQuery = Object.assign({}, app.$route.query);
                  delete cleanQuery.token;
                  var now_url = buildRouteUrl(route_path, cleanQuery);
                  window.location.href = now_url;
                  return;
                }

                //校验token是否过期以及正确
                app.$http
                  .post(api_url + "action=check_user_token&id=" + id + "&token=" + token)
                  .then((tokenRes) => {
                    console.log("校验user_token是否ok", tokenRes);
                    if (tokenRes.data.sta == "403") {
                      redirectToWechatAuth();
                      return;
                    }
                    if (tokenRes.data.sta != "200") {
                      this.huace_status = 0;
                      this.hauce_errmsg = tokenRes.data.msg;
                      return;
                    }
                    //token 校验成功后再记录访问，避免携带失效 token。
                    var pathUrl = api_url + `action=add_history_log&id=${id}&token=${token}`;
                    return app.$http.request({ url: pathUrl, method: "GET" })
                      .then((logRes) => {
                        console.log("addvistlog", logRes);
                      });
                  }).catch(err => {
                    this.huace_status = 0;
                    this.hauce_errmsg = "系统升级中，请稍后再访问！";
                    console.log(err);
                  });
              }




              //如果是0需要完善信息才能继续
              if (this.is_fang == "0") {
                document.title = "请先完善信息";
                return;
              }
            }).catch(err => {
              this.huace_status = 0;
              this.hauce_errmsg = "系统升级中，请稍后再访问！";
              return;
              console.log(err);
            });







        }
      },

    },
    created() {

      //在这里做一个域名跳转携带之前参数 ,目前仅仅是测试阶段
      /*
      const currentDomain = window.location.hostname;
      const urlPath = window.location.pathname;
      const queryStr = window.location.search;
      const hashStr = window.location.hash;
      const originalParams = urlPath + queryStr + hashStr;
      console.log("currentDomain:", currentDomain);
      if (currentDomain == 'hua.lizengtong.com' || currentDomain == 'bak_localhost' || currentDomain ==
        'newxiu.lizengbang.com') {
        let targetDomain = "http://huace.kuguanbang.com";
        let finalUrl = targetDomain + originalParams;
        console.log("targetDomain:", finalUrl);
        window.location.href = finalUrl;
        return;
      }
      */

      document.title = "电子画册v2.0";
      //初始化页面
      // 路由守卫先确定域名对应的画册 ID，再执行原有访问/授权检查。
      this.$router.onReady(() => {
        this.entryReady = true;
      });
    },
    watch: {
      '$route': function(to, from) {
        if (this.entryReady && from.name && this.albumAccess.ready && to.query.id !== from.query.id) {
          this.huace_status = '1';
          this.hauce_errmsg = '';
          this.is_fang = 1;
          this.isWeiXin();
        }
      },
      'albumAccess.ready': function(ready) {
        if (!this.entryReady || !ready) return;
        this.huace_status = '1';
        this.hauce_errmsg = '';
        this.is_fang = 1;
        this.isWeiXin();
      }
    },
  };
</script>

<style scoped>
  #app,
  body {
    width: 100%;
  }

  .tab {
    background-color: #f4f4f4;
  }

  .app-container {
    height: 100%;
    background-color: #fff;
  }

  /* 公共样式表css -bind*/
  html,
  body {
    color: #333;
    margin: 0;
    height: 100%;
    font-family: "Myriad Set Pro", "Helvetica Neue", Helvetica, Arial, Verdana,
      sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-weight: normal;
  }

  * {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }

  a {
    text-decoration: none;
    color: #000;
  }

  a,
  label,
  button,
  input,
  select {
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }

  img {
    border: 0;
  }

  body {
    background: #f7f7f7;
    color: #666;
  }

  html,
  body,
  div,
  dl,
  dt,
  dd,
  ol,
  ul,
  li,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  blockquote,
  pre,
  button,
  fieldset,
  form,
  input,
  legend,
  textarea,
  th,
  td {
    margin: 0;
    padding: 0;
  }

  a {
    text-decoration: none;
    color: #08acee;
  }

  button {
    outline: 0;
  }

  img {
    border: 0;
  }

  button,
  input,
  optgroup,
  select,
  textarea {
    margin: 0;
    font: inherit;
    color: inherit;
    outline: none;
  }

  li {
    list-style: none;
  }

  a {
    color: #666;
  }

  .clearfix::after {
    clear: both;
    content: ".";
    display: block;
    height: 0;
    visibility: hidden;
  }

  .clearfix {}

  /* 必要布局样式css */

  .aui-code-box {
    padding: 40px;
    text-align: center;
  }

  .aui-code-box button {
    background: #39bc30;
    height: 45px;
    line-height: 45px;
    border: none;
    color: #c5e9b3;
    border-radius: 30px;
    width: 100%;
    font-size: 0.98rem;
  }

  .aui-code-box h2 {
    color: #333333;
    font-size: 1.4rem;
    font-weight: normal;
  }

  .aui-code-box p {
    color: #cccccc;
    font-size: 0.85rem;
    /* position: relative; */
    width: 100%;
    /* padding-top: 10px; */
  }

  .aui-code-line {
    position: relative;
  }

  .aui-code-line:after {
    content: "";
    position: absolute;
    z-index: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 1px;
    border-bottom: 1px solid #d9d9d9;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
    -webkit-transform-origin: 0 100%;
    transform-origin: 0 100%;
  }

  .aui-code-line-input {
    padding: 10px 0;
    height: 50px;
    width: 100%;
    font-size: 14px;
    background: none;
    border: none;
    color: #333;
  }

  .aui-btn-default {
    float: right;
    position: absolute;
    right: -9px;
    top: 39px;
    color: #39bc30;
    background: none;
    border: none;
    margin-top: -35px;
    width: 100px;
    height: 40px;
  }

  .aui-code-line em {
    position: absolute;
    left: 0;
    top: 17px;
    color: #333;
    font-style: normal;
    font-size: 14px;
  }

  .aui-code-btn {
    padding-top: 30px;
  }

  .aui-code-box .form1 {
    padding-top: 50px;
    position: relative;
  }

  .aui-code-line-clear span a {
    text-indent: -999px;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue